import * as Cons from "../utils/Constants";

const initialState = {
  isFetching: false,
  isFail: false,
  result: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case Cons.GET_USER_INFO_DATA:
      return { ...state, isFetching: false, isFail: false, result: payload };

    case Cons.GET_USER_INFO_FAILED:
      return { ...state, isFetching: false, isFail: true, result: [] };

    default:
      return state;
  }
};
